export default "__VITE_ASSET__CZHy9KOP__"